/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PolicyDetailsPage, OfferingsPage, LocationsPage, DeclarationPage, RiskAnalysisPage, SuccessPage, PolicyInfoPage} from 'premier-capability-policyjob-react';
import { PaymentDetailsPage } from 'gw-capability-quoteandbind-common-react';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';
import CoverablesPage from './pages/Coverables/CoverablesPage';
import SingleCoverablePage from './pages/Coverables/SingleCoverablePage';
import CoveragesPage from './pages/Coverages/CoveragesPage';
import ExposuresPage from './pages/Exposures/ExposuresPage';
import CommercialPage from './pages/Commercial/CommercialPage';
import PersonalPage from './pages/Personal/PersonalPage';
import InfoPage from './pages/Info/InfoPage';
import QuestionsPage from './pages/Questions/QuestionsPage';
import QuotePage from './pages/Quote/QuotePage';
import LiabilityCoveragesPage from './pages/LiabilityCoverages/LiabilityCoveragesPage';

setComponentMapOverrides(
    {
        // wizard pages
        PremierCLInfoPage: { component: 'PremierCLInfoPage' },
        PremierOfferingsPage: { component: 'PremierOfferingsPage'},
        PremierCLPolicyDetailsPage: { component: 'PremierCLPolicyDetailsPage'},
        PremierCLLocationsPage: { component: 'PremierCLLocationsPage'},
        PremierCLQuestionsPage: { component: 'PremierCLQuestionsPage' },
        PremierCLSingleCoverablePage: { component: 'PremierCLSingleCoverablePage' },
        PremierCLExposuresPage: { component: 'PremierCLExposuresPage' },
        PremierCLCommercialPage: { component: 'PremierCLCommercialPage' },
        PremierCLPersonalPage: { component: 'PremierCLPersonalPage' },
        PremierCLCoveragesPage: { component: 'PremierCLCoveragesPage' },
        PremierCLCoverablesPage: { component: 'PremierCLCoverablesPage' },
        PremierCLQuotePage: { component: 'PremierCLQuotePage' },
        PremierCLPolicyInfoPage: { component: 'PremierCLPolicyInfoPage' },
        PremierCLPaymentDetailsPage: { component: 'PremierCLPaymentDetailsPage' },
        PremierCLSuccessPage: { component: 'PremierCLSuccessPage' },
        PremierCLDeclarationPage: { component: 'PremierCLDeclarationPage'},
        PremierCLRiskAnalysisPage: { component: 'PremierCLRiskAnalysisPage'},
        PremierCLLiabilityCoveragesPage: { component: 'PremierCLLiabilityCoveragesPage' },
    },
    {
        // wizard pages
        PremierCLInfoPage: InfoPage,
        PremierOfferingsPage: OfferingsPage,
        PremierCLPolicyDetailsPage: PolicyDetailsPage,
        PremierCLLocationsPage: LocationsPage,
        PremierCLQuestionsPage: QuestionsPage,
        PremierCLSingleCoverablePage: SingleCoverablePage,
        PremierCLExposuresPage: ExposuresPage,
        PremierCLCommercialPage: CommercialPage,
        PremierCLPersonalPage: PersonalPage,
        PremierCLCoveragesPage: CoveragesPage,
        PremierCLCoverablesPage: CoverablesPage,
        PremierCLQuotePage: QuotePage,
        PremierCLPolicyInfoPage: PolicyInfoPage,
        PremierCLPaymentDetailsPage: PaymentDetailsPage,
        PremierCLSuccessPage: SuccessPage,
        PremierCLDeclarationPage : DeclarationPage,
        PremierCLRiskAnalysisPage: RiskAnalysisPage,
        PremierCLLiabilityCoveragesPage: LiabilityCoveragesPage,
    }
);
// eslint-disable-next-line import/prefer-default-export
export { CodegenWizard, CodegenContext };
